import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MatTableModule} from "@angular/material/table";
import {TransactionService} from "../../services/api/transaction/transaction.service";
import {TransactionResponse} from "../../services/api/transaction/model";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {HeadComponent} from "../../components/head/head.component";
import {MatIcon} from "@angular/material/icon";
import {MatButton, MatFabButton, MatIconButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {PopinComponent} from "../../components/popin/popin.component";
import {FormsModule} from "@angular/forms";
import {formatDateToMMDDYYYY} from "../../utils/helper";


@Component({
  selector: 'app-transaction-page',
  standalone: true,
  imports: [
    MatTableModule,
    NgForOf,
    HeadComponent,
    MatIcon,
    MatButton,
    MatFabButton,
    MatIconButton,
    MatLabel,
    MatFormField,
    NgIf,
    PopinComponent,
    FormsModule,
    NgClass
  ],
  templateUrl: './transaction-page.component.html',
  styleUrl: './transaction-page.component.css'
})
export class TransactionPageComponent implements OnInit, OnChanges {
  dataSource: TransactionResponse[] = [];
  filterData: TransactionResponse[] = [];
  displayedColumns: string[] = ['updated_date', 'type', 'item_name', 'expiration_date', 'location', 'actual_quantity', 'added_by'];

  optionFilter = 'all';
  nameFilter = '';
  dateFilter = 'all';
  isFilterOpen = false;
  datePopin = false;
  filters = [
    {'text': 'Tous', 'type': 'all', selected: true },
    {'text': '30 derniers jours', 'type': '30 days', selected: false },
    {'text': '7 derniers jours', 'type': '7 days', selected: false },
    {'text': 'Aujourdhui', 'type': 'today', selected: false },
  ]

  constructor(
    private transactionService: TransactionService,
  ) {

  }

  ngOnInit() {
    this.getTransactions();
  }

  ngOnChanges() {
    this.getTransactions();
  }


  getTransactions() {
    this.transactionService.getTransactions().subscribe(res => {
      this.dataSource = res.reverse();
      this.filterData = res.sort((a, b) => b.updated_date.localeCompare(a.updated_date));
    })
  }


  setFilter(type: string, value: any) {
    if (type === "name") {
      this.nameFilter = value;
    } else if (type === "date") {
      this.dateFilter = value;
      this.filters.forEach((filter, i) => {
        filter.selected = filter.type === value;
      });
    } else if (type === "option") {
      if (type === this.optionFilter) {
        this.optionFilter = "";
      } else {
        this.optionFilter = value
      }
    }
    this.applyFilters();
  }

  filterTransactionByType(transactionType: string, data: TransactionResponse[]): TransactionResponse[] {
    if (transactionType === "all") {
      return data;
    } else {
      this.optionFilter = transactionType;
      return data.filter(transaction => transaction.type === transactionType);
    }
  }

  filterTransactionByDate(dateRange: string | string[], data: TransactionResponse[]): TransactionResponse[] {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let startDate: Date;
    let endDate: Date;

    if (typeof dateRange === "string") {
      if (dateRange === "all") {
        return data;
      }
      if (dateRange === "today") {

        return data.filter((transaction) => {
          const transactionDate = new Date(transaction.updated_date);
          transactionDate.setHours(0, 0, 0, 0);
          return transactionDate.getTime() === today.getTime();
        });
      } else if (dateRange === "7 days") {
        startDate = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        endDate = today;
      } else if (dateRange === "30 days") {
        startDate = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
        endDate = today;
      }
    } else if (Array.isArray(dateRange)) {
      startDate = new Date(dateRange[0]);
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date(dateRange[1]);
      endDate.setHours(0, 0, 0, 0);
    }

    return data.filter((transaction) => {
      const transactionDate = new Date(transaction.updated_date);
      transactionDate.setHours(0, 0, 0, 0);
      return transactionDate >= startDate && transactionDate <= endDate;
    });
  }

  filterByRangeDate(startDate: string, endDate: string) {
    if (startDate <= endDate) {
      this.setFilter('date', [startDate, endDate]);
      this.datePopin = false;
    }
  }

  applyFilters() {
    this.filterData = this.filterTransactionByType(this.optionFilter, this.dataSource);
    this.filterData = this.filterTransactionByDate(this.dateFilter, this.filterData);
  }

  toggleDropdown() {
    this.isFilterOpen = !this.isFilterOpen;
  }

  openDatePopin() {
    this.datePopin = true;
  }

  protected readonly formatDateToMMDDYYYY = formatDateToMMDDYYYY;
}
